import { Link } from "react-router-dom";

export const BisInfoCard = ({ wo }) => {
  if (wo.origin !== "BIS") return null;
  return (
    <section className="fade-up space-y-3 rounded-xl border border-border bg-card/40 p-5" data-testid="wo-bis-card">
      <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">BIS · {wo.bis_kind_label}</h2>
      <div className="text-sm">OS origen <Link className="text-primary" to={`/admin/os/${wo.bis_origin_wo_id}`} data-testid="wo-bis-origin-link">{wo.bis_origin_folio}</Link>
        {wo.bis_root_folio !== wo.bis_origin_folio && <> · OS principal <Link className="text-primary" to={`/admin/os/${wo.bis_root_wo_id}`}>{wo.bis_root_folio}</Link></>}</div>
      <p className="text-xs text-muted-foreground">Requiere firma del cliente al terminar.</p>
      {(wo.replacements || []).map((r) => (
        <div key={r.id} className="rounded-lg border border-border p-3 text-sm" data-testid={`wo-bis-rep-${r.id}`}>
          <div><span className="text-muted-foreground">Sustituye:</span> {[r.old.type_name, r.old.brand, r.old.model].filter(Boolean).join(" · ")}{r.old.serial ? ` · S/N ${r.old.serial}` : ""}</div>
          <div className="text-xs text-muted-foreground">Destino: {r.destination_label}{r.custodian ? ` · ${r.custodian} (${r.custody_date})` : ""}{r.new.model ? ` · Nuevo: ${r.new.model}${r.new.serial ? ` S/N ${r.new.serial}` : ""}` : ""}</div>
        </div>
      ))}
    </section>
  );
};
